import './internal-banner.scss';

export const InternalBanner = ({
    page
}) => {
    return <section id='internal-banner'>
        <div className="container">
            <div className="banner-area">
                <h1>{ page?.post_title ?? 'Undefined Title' }</h1>
            </div>
        </div>
    </section>
}